import React, { useEffect, useContext } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { LanguageContext } from '../Context/LanguageContext';

function Services() {
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const servicesData = {
    en: [
      {
        id: 1,
        title: 'IT Solutions',
        description: 'Smart software, infrastructure, and tech systems tailored to your business.',
        icon: 'fa-solid fa-server',
      },
      {
        id: 2,
        title: 'Education Solutions',
        description: 'Innovative e-learning platforms and tools for interactive education.',
        icon: 'fa-solid fa-graduation-cap',
      },
      {
        id: 3,
        title: 'Marketing Solutions',
        description: 'Digital marketing strategies to grow your brand and reach.',
        icon: 'fa-solid fa-bullhorn',
      },
      {
        id: 4,
        title: 'Sales Solutions',
        description: 'CRM and automation systems that boost your sales performance.',
        icon: 'fa-solid fa-chart-line',
      },
    ],
    ar: [
      {
        id: 1,
        title: 'حلول تكنولوجيا المعلومات',
        description: 'أنظمة وبرمجيات ذكية تناسب احتياجاتك التقنية.',
        icon: 'fa-solid fa-server',
      },
      {
        id: 2,
        title: 'حلول التعليم',
        description: 'منصات تعليمية تفاعلية وأدوات مبتكرة للتعلم الذكي.',
        icon: 'fa-solid fa-graduation-cap',
      },
      {
        id: 3,
        title: 'حلول التسويق',
        description: 'استراتيجيات تسويق رقمي لزيادة انتشار علامتك التجارية.',
        icon: 'fa-solid fa-bullhorn',
      },
      {
        id: 4,
        title: 'حلول المبيعات',
        description: 'أنظمة CRM وأتمتة تعزز أداء المبيعات.',
        icon: 'fa-solid fa-chart-line',
      },
    ],
  };

  const services = servicesData[language];

  return (
    <div
      className="container-fluid services-section py-5 mt-4"
      dir={language === 'ar' ? 'rtl' : 'ltr'}
      id="services"
      style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e9ecef 100%)',
      }}
    >
      <div className="container">
        <h2
          className="text-center mb-2 text-secondary fw-bold"
          data-aos="fade-up"
        >
          {language === 'ar' ? 'خدماتنا' : 'Our Services'}
        </h2>
        <p
          className="text-center mb-5 text-secondary"
          style={{ maxWidth: 600, margin: '0 auto' }}
        >
          {language === 'ar'
            ? 'نقدم لك حلولاً متكاملة في مجالات التقنية والتعليم والتسويق والمبيعات.'
            : 'We offer integrated solutions in IT, education, marketing, and sales.'}
        </p>

        <div className="row g-4 justify-content-center">
          {services.map((service, index) => (
            <div
              className="col-lg-3 col-md-6 d-flex align-items-stretch"
              key={service.id}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div
                className="card h-100 shadow-sm border-0 text-center rounded-4 service-card"
                style={{
                  transition: 'all 0.3s ease-in-out',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 25px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.05)';
                }}
              >
                <div className="card-body d-flex flex-column justify-content-center align-items-center p-4">
                  <div
                    className="icon-box rounded-circle mb-3 d-flex justify-content-center align-items-center"
                    style={{
                      width: 70,
                      height: 70,
                      backgroundColor: '#f3f4f6',
                      fontSize: '1.8rem',
                      color: '#333',
                    }}
                  >
                    <i className={service.icon}></i>
                  </div>
                  <h5 className="fw-bold text-df mb-3">{service.title}</h5>
                  <p className="" style={{ minHeight: '60px', fontSize: '0.95rem' }}>
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services;
